module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "header-nav__item header-nav__item__notifications pos-relative no-selection js-toggle-notifications",
    class: {
      active: _vm.show
    },
    on: {
      "click": function($event) {
        return _vm.toggle($event)
      }
    }
  }, [_c('div', {
    staticClass: "inline-block",
    class: {
      'animated swing infinite': _vm.unReadCounter
    }
  }, [_c('span', {
    staticClass: "icon-bell js-toggle-notifications",
    staticStyle: {
      "margin-right": "0",
      "font-size": "13px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unReadCounter),
      expression: "unReadCounter"
    }],
    staticClass: "notify-number js-toggle-notifications"
  }, [_vm._v(_vm._s(_vm.unReadCounter))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "notifications_list pos-absolute bg-white rounded"
  }, [_c('div', {
    staticClass: "notifications__header popup_header"
  }, [_c('h4', {
    staticClass: "left marg-10-left"
  }, [_vm._v(_vm._s(_vm.unReadCounter) + " " + _vm._s(_vm.$t('vue2.notifications.notifications')))]), _vm._v(" "), _c('div', {
    staticClass: "notifications__header__tabs"
  }, [_c('button', {
    staticClass: "bttn right",
    class: {
      bttn_active: _vm.onlyUnreadMessagesActive
    },
    on: {
      "click": _vm.getMessagesUnread
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.notifications.unread')) + "\n\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn right",
    class: {
      bttn_active: !_vm.onlyUnreadMessagesActive
    },
    on: {
      "click": _vm.getMessages
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.notifications.all')) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "notifications__body js-notifications-body-scroll"
  }, [_c('div', [(_vm.isInitialLoad) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff",
      "isSmall": true
    }
  }) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messages.length === 0),
      expression: "messages.length === 0"
    }],
    staticClass: "pad-20 center"
  }, [_c('div', {
    staticClass: "icon-checkmark-circle marg-10-bottom",
    staticStyle: {
      "font-size": "22px"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.notifications.no_new_notifications')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: message.id,
      staticClass: "notifations__body__message clearfix overflow pos-relative"
    }, [_c('a', {
      staticClass: "flex",
      class: {
        is_read: message.read
      },
      attrs: {
        "href": message.link
      }
    }, [_c('div', {
      staticClass: "notifications__message__image-wrapper",
      on: {
        "click": function($event) {
          return _vm.readStatusRead($event, index, message.id, true)
        }
      }
    }, [_c('img', {
      staticClass: "notifications__body__message__image rounded",
      attrs: {
        "src": message.user.profile_image_thumb
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "notifications__body__message__header",
      on: {
        "click": function($event) {
          return _vm.readStatusRead($event, index, message.id, true)
        }
      }
    }, [_c('p', {
      staticClass: "text-dark bold marg-10-bottom"
    }, [_vm._v(_vm._s(message.header))]), _vm._v(" "), _c('p', {
      staticClass: "text-dark"
    }, [_vm._v(_vm._s(message.body))]), _vm._v(" "), _c('div', {
      staticClass: "notifications_body__message__footer"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.notifications.sent_from')) + " " + _vm._s(message.user.name) + " - " + _vm._s(_vm._f("fromNow")(message.created_at)))])])]), _vm._v(" "), _c('div', {
      staticClass: "notifications__body__message__isread css_show_tooltip",
      on: {
        "click": function($event) {
          return _vm.changeReadStatus($event, index, message.id, !message.read)
        }
      }
    }, [_c('div', {
      staticClass: "mark_as_read",
      class: {
        is_read: message.read
      }
    }, [_c('span', {
      staticClass: "icon-checkmark4"
    })])])])])
  })], 2), _vm._v(" "), (_vm.messages.length > 4 && !_vm.isAllLoaded) ? _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.handleScrolledToBottom),
      expression: "handleScrolledToBottom"
    }],
    staticClass: "message-loader",
    attrs: {
      "div": ""
    }
  }, [_c('Loader', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "bg-color": "#fff",
      "isSmall": true
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unReadCounter),
      expression: "unReadCounter"
    }],
    staticClass: "notifications__footer box-sizing"
  }, [_c('span', {
    staticClass: "pointer pad-10-0 notifications__footer__link ",
    on: {
      "click": _vm.markAllAsRead
    }
  }, [_c('span', {
    staticClass: "icon-checkmark-circle marg-10-right"
  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.notifications.mark_all_as_read')) + "\n      ")])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a31f2a1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 1674
// module chunks = 1